export const administrationAccountsSiteLocations = {
    template: require('./administration-accounts-site-locations.html'),
    controller: 'AdministrationAccountsSiteLocationsController'
};
